import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

import { UserDto } from 'src/app/api';

import { CerSessionService } from 'src/cer/cer-session/cer-session.service';

@Component({
  selector: 'cer-login-menu',
  templateUrl: './cer-login-menu.component.html',
  styleUrls: ['./cer-login-menu.component.css']
})
export class CerLoginMenuComponent implements OnInit {
  protected isAuthenticated: Observable<boolean>;
  protected userName: string = '';
  protected userNameShort: string = '';
  protected defaultIdentityActive: boolean = true;

  constructor(private sessionService: CerSessionService) { }

  ngOnInit() {
    this.isAuthenticated = this.sessionService.isAuthenticated$;
    this.sessionService.user.user$.subscribe(user => 
      this.initUser(user)
    );
  }

  //  this.defaultIdentityActive = userVm?.environment.defaultIdentityActive;

  private initUser(user: UserDto): void {
    if (user != null) {
      this.userName = user.name;
      this.userNameShort = user.shortName;
    }
    else {
      this.userName = '';
      this.userNameShort = '';
    }
  }
}
